import { mapGetters } from 'vuex'

import { applyUpdateSW } from '@/utils'

import render from './render'

export default {
  name: 'Notification',

  computed: {
    ...mapGetters({
      newVersion: 'version/new',
      hasNewVersion: 'version/hasNewVersion'
    })
  },

  methods: {
    applyAvailableUpdate() {
      return applyUpdateSW()
    }
  },

  render
}
